import { FeatureProductCell } from "@pages/platform-analysis-v2/_id/components/virtualized-table/components/rendered-items/feature-cells/product";

export const SummaryAnalysisTableDataValueCell = FeatureProductCell;
